import React, { useRef } from 'react';
import { useReactiveVar } from '@apollo/client';

import { IFormImperativeHandleProps } from '../../../../common';
import { EcpFiltersModal as EcpFiltersModalView } from './ecp-filters-modal';
import { IEcpFiltersModalProps } from './ecp-filters-modal.models';
import { filterParamsExternal } from '../../../../../graphql/ecp-locator/ecp-locator.cache';
import { useUpdateEcpStores } from '../hooks/use-update-ecp-stores';
import { useActionsInProgress } from '../../../../../graphql';
import { isFilterStateDefault } from './utils/is-filter-state-default';
import { DEFAULT_FILTERS_EXTERNAL } from '../../../../../constants/ecp-locator';
import { TFiltersData } from '../../../../../models';

export const EcpFiltersModal = ({ ...props }: IEcpFiltersModalProps): JSX.Element => {
  const { onClose } = props;
  const ecpFiltersFormRef = useRef<IFormImperativeHandleProps>(null);
  const currentFilters = useReactiveVar(filterParamsExternal);
  const { updateStores } = useUpdateEcpStores();
  const { addActionInProgress, removeActionInProgress } = useActionsInProgress();
  const isResetButtonDisabled = isFilterStateDefault(currentFilters);

  const requestToUpdateStores = async (filters: TFiltersData) => {
    try {
      addActionInProgress();
      await updateStores({ filters });
    } finally {
      removeActionInProgress();
      onClose!();
    }
  };

  const handleApplyFilters = async (values: TFiltersData) => {
    await requestToUpdateStores({
      ...values,
    });
  };

  const handleApplyFiltersButtonClick = () => {
    if (ecpFiltersFormRef.current) {
      ecpFiltersFormRef.current.submit();
    }
  };

  const handleResetFilters = async () => {
    await requestToUpdateStores({
      ...DEFAULT_FILTERS_EXTERNAL,
    });
  };

  return (
    <EcpFiltersModalView
      {...props}
      ref={ecpFiltersFormRef}
      defaultValues={currentFilters}
      isResetButtonDisabled={isResetButtonDisabled}
      onApplyFilters={handleApplyFilters}
      onSubmitButtonClick={handleApplyFiltersButtonClick}
      onResetFilters={handleResetFilters}
    />
  );
};
